import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { PianoService } from 'src/app/services/piano/piano.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-crea-obiettivo-aziendali',
  templateUrl: './dialog-crea-obiettivo-aziendali.component.html',
  styleUrls: ['./dialog-crea-obiettivo-aziendali.component.scss'],
  standalone: false,
})
export class DialogCreaObiettivoAziendaliComponent implements AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public formObiettivoAziendalePiano = new FormGroup({
    id: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),

    descrizione: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),
    note: new FormControl<string>('', {
      nonNullable: true,
      validators: [],
    }),

    creatoDaContesto: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
    selected: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
    compilato: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [],
    }),
  });

  constructor(
    public dialogRef: MatDialogRef<DialogCreaObiettivoAziendaliComponent>,
    private readonly pianoService: PianoService,
    private readonly utilityService: UtilityService,
    private readonly utenteService: UtenteService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      obiettivoAziendalePiano: any;
      idContest: string;
      idAmbito: string;
      idTematica: string;
      contesto: string;
      isPermessoSoloRead: boolean;
    },
  ) {}

  ngAfterViewInit(): void {
    if (this.data?.obiettivoAziendalePiano) {
      Object.keys(this.data.obiettivoAziendalePiano).forEach((value, index, array) => {
        this.formObiettivoAziendalePiano
          .get(value)
          ?.setValue(this.data.obiettivoAziendalePiano[value]);
      });
    }

    if (this.data?.isPermessoSoloRead) {
      this.formObiettivoAziendalePiano.disable();
    }
  }

  public salva() {
    if (this.formObiettivoAziendalePiano.valid) {
      if (this.data.idContest) {
        return this.salvaInContesto();
      }

      const id = this.formObiettivoAziendalePiano.get('id')?.value;

      if (id) {
        return this.pianoService
          .putObiettiviAziendaliPiano(id, this.formObiettivoAziendalePiano.getRawValue())
          .subscribe({
            next: () => {
              this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
                duration: 2000,
                panelClass: ['success-snackbar'],
              });
              this.dialogRef.close();
            },
            error: (err: any) => {
              this.utilityService.openDialog({
                titolo: 'Attenzione',
                descrizione: err.error.message,
                bottoni: [{ nome_btn: 'Chiudi' }],
              });
            },
          });
      } else {
        return this.pianoService
          .postObiettiviAziendaliPiano(this.formObiettivoAziendalePiano.getRawValue())
          .subscribe({
            next: () => {
              this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
                duration: 2000,
                panelClass: ['success-snackbar'],
              });
              this.dialogRef.close();
            },
            error: () => {
              this.utilityService.openDialog({
                titolo: 'Attenzione',
                descrizione: 'Errore nel salvataggio ',
                bottoni: [{ nome_btn: 'Chiudi' }],
              });
            },
          });
      }
    } else {
      Object.values(this.formObiettivoAziendalePiano.controls).forEach((control) => {
        control.markAsTouched();
      });
    }
    return null;
  }
  /**
   * Metodo che mi salva un nuovo obiettivo effimero in piano di sostenibilità
   * @returns
   */
  public salvaInContesto() {
    const objObiettivoAz = {
      ...this.data.obiettivoAziendalePiano,
      ...this.formObiettivoAziendalePiano.getRawValue(),
    };

    if (!this.formObiettivoAziendalePiano.get('id')?.value) {
      this.formObiettivoAziendalePiano.get('creatoDaContesto')?.setValue(true);
    }

    this.pianoService.putObiettiviAziendaliEffimeri(this.data.idContest, objObiettivoAz).subscribe({
      next: (result: any) => {
        this.spinnerOver.hide();
        this.mostraMessaggioSnackbar('Salvataggio effettuato');
        this.dialogRef.close(result);
      },
      error: (err: any) => {
        this.spinnerOver.hide();
        console.error("Errore durante il salvataggio dell'obiettivo aziendale:", err);
        this.mostraMessaggio('Attenzione', "Errore nel salvataggio dell'obiettivo aziendale");
      },
    });
  }

  private mostraMessaggio(titolo: string, descrizione: string) {
    this.utilityService.openDialog({
      titolo: titolo,
      descrizione: descrizione,
      bottoni: [{ nome_btn: 'Chiudi' }],
    });
  }

  private mostraMessaggioSnackbar(messaggio: string) {
    this.utilityService.openSnackBar(messaggio, '', {
      duration: 2000,
      panelClass: ['success-snackbar'],
    });
  }
}
